/* loaded by smart-asset */
export default require("./9~lBsCODaB.svg")